import script from "./popPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./popPrompt.vue?vue&type=script&setup=true&lang=js"

import "./popPrompt.vue?vue&type=style&index=0&id=13143a3a&lang=scss"

const __exports__ = script;

export default __exports__